export default class FoldersAndLabelsController {
    /** @ngInject */
    constructor($state, $timeout) {
        this.$state = $state;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.tabs = [
            {
                title: 'Folders',
                state: 'main.folders-and-labels.folders'
            },
            {
                title: 'Labels',
                state: 'main.folders-and-labels.labels'
            }
        ];
        this.tabs.forEach((tab) => {
            tab.isActive = this.$state.includes(tab.state);
        });
        this.$timeout(() => {
            this.onTabClickProxy = this.onTabClick;
        });
    }

    // TODO: Refactor this
    // This no-op callback is needed to prevent state manipulation on first load
    onTabClickProxy() {} // eslint-disable-line class-methods-use-this

    onTabClick({ tab }) {
        this.$state.go(tab.state);
    }
}



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders-and-labels.controller.js